import { Controller } from "@hotwired/stimulus"

// 解析で読み取れなかった項目に印を付ける。値が空なだけの欄と区別が付かないと、
// 「図面に書いていない」のか「読み落とした」のかを利用者が判断できない。
// 入力されたら印を外す（フォームの検証と同じ感覚で、埋めれば解消される）。
//
// 空室の入力欄は他の画面（手動登録・オフィス空室登録・空室編集）と共有しているため、
// パーシャルには手を入れず、この画面でだけ描画後に印を付ける。
export default class extends Controller {
  static values = { names: Array }
  declare readonly namesValue: string[]

  private fields: HTMLElement[] = []

  connect() {
    this.fields = this.namesValue.flatMap((name) =>
      Array.from(this.element.querySelectorAll<HTMLElement>(`[name$="[${name}]"]`))
    )
    this.fields.forEach((field) => {
      this.refresh(field)
      field.addEventListener("input", this.handle)
      field.addEventListener("change", this.handle)
    })
  }

  disconnect() {
    this.fields.forEach((field) => {
      field.removeEventListener("input", this.handle)
      field.removeEventListener("change", this.handle)
    })
    this.fields = []
  }

  private handle = (event: Event) => {
    this.refresh(event.currentTarget as HTMLElement)
  }

  // 入力済みなら印を外す。ページを移動して戻ってきたときも同じ判定で復元される。
  private refresh(field: HTMLElement) {
    field.classList.toggle("is-unread", !this.filled(field))
  }

  private filled(field: HTMLElement) {
    if (field instanceof HTMLInputElement && (field.type === "checkbox" || field.type === "radio")) {
      return field.checked
    }
    const value = (field as HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement).value
    return value !== undefined && value.trim() !== ""
  }
}
